import { AUTHENTICATION_SETTING_API, PASSWORD_POLICY_URL } from '@/services/constants';
import axiosClient from '../axiosClient';

const AuthSettingServices = {
  createAuth: async (body: any) => {
    try {
      const response = await axiosClient.post(`${AUTHENTICATION_SETTING_API}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  fetchAuth: async (params: any) => {
    try {
      const response = await axiosClient.get(`${AUTHENTICATION_SETTING_API}`, {
        params
      });

      return response.data;
    } catch (err: any) {
      return err?.response?.data;
    }
  },
  updateAuth: async (body: any, authId: string) => {
    try {
      const response = await axiosClient.put(`${AUTHENTICATION_SETTING_API}/${authId}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  updatePasswordPolicy: async (body: any, authId: string) => {
    try {
      const response = await axiosClient.put(`${PASSWORD_POLICY_URL}/${authId}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
};

export default AuthSettingServices;
